export default __webpack_public_path__ + "static/media/https-hijau-daun-netlify-app.eddef18d.png";